





















































































































import { CertificateInfo, OrderItemPayload, ProductInfo } from '@luxtag/papybase';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { ProductUIInfo, ProductUIInfoFuse } from '@/store/modules/product';
import { filter, map } from 'lodash';
import DateTimePicker from '@/components/global/input/DateTimePicker.vue';
import DownloadCSVMixin from '@/mixins/vue/DownloadCSVMixin';
import DownloadXLSMixin from '@/mixins/vue/DownloadXLSMixin';
import Fuse from 'fuse.js';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import ProductIntegrationMixin from '@/mixins/vue/ProductIntegrationMixin';
import ProductList from '@/components/product/product-list/ProductList.vue';
import SearchedProductMixin from '@/mixins/vue/SearchedProductMixin';
import SimpleDialog from '@/components/global/SimpleDialog.vue';
import moment from 'moment';
import { order } from '@/plugins/papybase/papybaseInit';
import theme from '@/config/config-ui';

@Component({
    components: {
        ProductList,
        DateTimePicker,
        SimpleDialog,
    },
})
export default class ProductListContainer extends Mixins(
    ProductIntegrationMixin, SearchedProductMixin, DownloadCSVMixin, DownloadXLSMixin, IsMobileMixin,
) {
    @Prop() public products!: CertificateInfo[];
    @Prop({ default: '' }) public title!: string;

    public selectedProductIds: number[] = [];

    public showPurchaseConfirmationDialog = false;

    public executeLoading = false;

    // set show filter feature as true to release it
    public showFilterFeature = false;
    public showFilters = false;

    public fromDate: Date | null = null;
    public fromTime = '00:00';
    public toDate: Date | null = null;
    public toTime = '23:59';

    public productListContainerEvent(action: string, label: any) {
        this.$ga.event('Product list container', 'click', action, label);
    }

    public async created() {
        await this.integrateProductListFromBackEndToLocalStorage();
    }

    public initDownloadCSV() {
        this.productListContainerEvent('Download products CSV', 'Download');
        // this.downloadXLS(this.theProducts);
        this.downloadCSV(this.selectedProductIds);
    }

    public initOrderNFC() {
        this.showPurchaseConfirmationDialog = true;
    }

    public executeOrderNFC(isExecute: boolean) {
        if (isExecute) {
            this.executeLoading = true;
            const orderItemsPayload = map(this.selectedProductIds, (productId) => {
                const cert: CertificateInfo = this.$store.getters.getProduct(productId);
                console.log(cert.id);
                const orderItemPayload: OrderItemPayload = {
                    product_id: 1,
                    cert_id: cert.id,
                    qty: 1,
                };
                return orderItemPayload;
            });

            order.createOrder(this.jwt, orderItemsPayload).then((res) => {
                this.$router.push({ name: 'order-list' });
            }).catch((err) => {
                console.error(err);
            }).finally(() => {
                this.showPurchaseConfirmationDialog = false;
                this.executeLoading = false;
            });
        }
    }

    get jwt() {
        return this.$store.getters.getJwt;
    }

    get theProducts(): ProductUIInfoFuse[] {
        const that = this;
        let theProducts: ProductUIInfoFuse[] | undefined;
        if (this.$route.params.id) {
            const mappedProducts = map(this.products, product => this.translateProductToProductUI(product));
            const fuse = new Fuse(mappedProducts, this.fuseJSOptions);
            const result: any = fuse.search(this.$route.params.id);
            const theResult: ProductUIInfoFuse[] = result;
            theProducts = theResult;
        } else {
            theProducts = map(this.products, product => this.translateProductToProductUIFuse(product));
        }

        // start filtered
        // from date
        if (this.fromDate !== null) {
            const fromDateMoment = moment(this.fromDate);
            const fromTimeMoment = moment(this.fromTime, 'HH:mm');
            fromDateMoment.hour(fromTimeMoment.hour());
            fromDateMoment.minute(fromTimeMoment.minute());
            fromDateMoment.second(0);
            const fromDateFiltered = filter(theProducts, (product: ProductUIInfoFuse) => {
                const productMoment = moment(product.item.time);
                return productMoment.isAfter(fromDateMoment);
            });
            theProducts = fromDateFiltered;
        }

        // to date
        if (this.toDate !== null) {
            const toDateMoment = moment(this.toDate);
            const toTimeMoment = moment(this.toTime, 'HH:mm');
            toDateMoment.hour(toTimeMoment.hour());
            toDateMoment.minute(toTimeMoment.minute());
            toDateMoment.hour(23).minute(59).second(59);

            const toDateFiltered = filter(theProducts, (product: ProductUIInfoFuse) => {
                const productMoment = moment(product.item.time);
                return productMoment.isBefore(toDateMoment);
            });
            theProducts = toDateFiltered;
        }

        return theProducts;
    }
}
